import React from "react";
import { MdToday } from "react-icons/md";
import { useLiveContext } from "../../DataProvider/LiveContext/LiveContext";
import { getLastMonday, getNextSunday, getTodayString, isCurrentWeek, parseDate } from "../../../../functions/date";
import "./TodayIcon.css";

type TodayIconProps = {
  displayedDay: string
  onClick: (day: string) => void;
};

export const TodayIcon: React.FC<TodayIconProps> = ({ displayedDay, onClick }) => {
  const { anyLive } = useLiveContext();

  const showLiveIndicator = anyLive && !isCurrentWeek(displayedDay);

  return (
    <button
      className="menu-button"
      onClick={() => onClick(getTodayString())}
      aria-label="Gehe zur aktuellen Woche"
      title="Gehe zur aktuellen Woche"
    >
      <MdToday />
      {showLiveIndicator && <span className="live-indicator" />}
    </button>
  );
};
